import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, shallowEqual } from "react-redux";
import "../../stylesheet/prescription.css";
import Topnav from "../others/Topnav";
import DetailSummary from "./Details/DetailSummary";
// import Appointments from "./Details/Appointments";
// import NewAppointment from "./Details/NewAppointment";
import NewAppointment from "./Details/appointments/NewAppointment";
import Appointments from "./Details/appointments/Appointments";
import PatientNotes from "./Details/PatientNotes";
import PatientDocuments from "./Details/documents/PatientDocuments";
import NewDocument from "./Details/documents/NewDocument";
import NewNote from "./Details/NewNote";
import PatientPrescriptions from "./PatientPrescriptions";
import PatientBilling from "./Details/billings/PatientBilling";
import NewInvoice from "./Details/billings/NewInvoice";
import PatientAnalysis from "./PatientAnalysis";
import AddPrescription from "./Details/prescription/AddPrescription";
import { getSelectedPatient, getPatientByID, getAllAppointmentByID, getAllNotesByID } from "../../Utils/localStore";
import { IoChevronBack } from "react-icons/io5";

const PatientDetails = ({ notify }) => {
  const [loading, setLoading] = useState(true)
  const [filter, setFilter] = useState("Appointments");
  const [popup, setPopup] = useState("");
  const [currentPatient, setCurrentPatient] = useState({})
  const navigate = useNavigate()
  const [apts, setApts] = useState(null)
  const [notes, setNotes] = useState(null)

  const getLocalData = async () => {
    let response
    try {
      await getSelectedPatient().then(resp => response = resp[0])
      // console.log({ response }, localStorage.getItem('userIDfromLocal'));
      // const patient = await getPatientByID(localStorage.getItem('userIDfromLocal'))
      await getAppointments(response.localID)
      await getAllNotes(response.localID)
      setCurrentPatient(response)
      setLoading(false)
      return false
    } catch (error) {
      notify.error(error?.message, { position: notify.POSITION.TOP_CENTER })
      throw new Error(error)
    }
  }
  const getAppointments = async (id) => {
    const newApts = await getAllAppointmentByID(id)
    await getAllNotes()
    setApts(newApts)
  }
  const getAllNotes = async (id) => {
    const newNotes = await getAllNotesByID(id ?? currentPatient.localID)
    setNotes(newNotes)
  }
  useEffect(() => {
    const data = getLocalData()
  }, [])

  const getButtonText = () => {
    switch (filter) {
      case "Appointments":
        return "Add Appointment";
      case "newAppointment":
        return "Add Appointment";
      case "Notes":
        return "Add Note";
      case "Documents":
        return "Add Document";
      case "newDocument":
        return "Add Document";
      case "Prescriptions":
        return "Add Prescription";
      case "newPrescription":
        return "Add Prescription";
      case "Billing":
        return "Add Invoice";
      case "newInvoice":
        return "Add Invoice";
      case "Analytics":
        return "Update Vitals";
      default:
        return "";
    }
  };

  const buttonClick = async () => {
    if (filter === "Appointments") {
      setFilter("newAppointment");
    } else if (filter === "Documents") {
      setFilter("newDocument");
    } else if (filter === "Notes") {
      await getAllNotes()
      setPopup("newNote");
    } else if (filter === "Billing") {
      setFilter("newInvoice");
    } else if (filter === "Prescriptions") {
      setFilter("newPrescription");
    }
  };

  const closePopup = () => {
    setPopup("");
  };
  const handleModifyPatient = (newUpdate) => {
    setCurrentPatient(prevState => ({ ...prevState, status: newUpdate?.status }))
  }

  const newNoteRef = useRef(null);

  return (
    <div
      className={
        popup === "newNote" ? "bg-black bg-opacity-25" : "presctiption_body"
      }
    >
      <Topnav />
      {
        loading ? (
          <>
            <p>
              Loading Data
            </p>
          </>
        ) :
          (
            <div className="p-6">
              <div className="">
                {
                  <div className="mt-4">
                    <button onClick={(e) => {
                      e.preventDefault()
                      navigate(-1)
                    }}>
                      <div className="flex items-center">
                        <IoChevronBack size={30} /> <span>Back</span>
                      </div>
                    </button>
                  </div>
                }
              </div>
              <div className="p-5 border border-stone-500 rounded-md mt-12 mb-4 h-[840px] font-euclid-circular-a overflow-auto">
                <div className="flex justify-between items-center">
                  <h2 className="ml-3 text-zinc-800 text-opacity-80 text-lg font-semibold leading-7 tracking-wide">
                    {currentPatient?.patientName || '-'}

                  </h2>
                  <button
                    onClick={() => buttonClick()}
                    className="text-white h-[42px] px-3 pt-1 pb-[3px] rounded-[10px] justify-center items-center inline-flex bg-[#009fe3] text-center p-2 cursor-point text-base font-medium leading-[34.53px] tracking-wide"
                  >
                    {getButtonText()}
                  </button>
                </div>

                <div className="report_header mt-6 overflow-hidden">
                  <div className="button detail_options w-full overflow-x-auto">
                    <button
                      className={
                        filter === "Appointments" || filter === "newAppointment"
                          ? "active"
                          : ""
                      }
                      onClick={() => setFilter("Appointments")}
                    >
                      Appointments
                    </button>
                    <button
                      className={
                        filter === "Notes" || popup === "newNote" ? "active" : ""
                      }
                      onClick={() => setFilter("Notes")}
                    >
                      Notes
                    </button>
                    <button
                      className={
                        filter === "Documents" || filter === "newDocument"
                          ? "active"
                          : ""
                      }
                      onClick={() => setFilter("Documents")}
                    >
                      Documents
                    </button>
                    <button
                      className={
                        filter === "Prescriptions" || filter === "newPrescription"
                          ? "active"
                          : ""
                      }
                      onClick={() => setFilter("Prescriptions")}
                    >
                      Prescriptions
                    </button>
                    <button
                      className={
                        filter === "Billing" || filter === "newInvoice" ? "active" : ""
                      }
                      onClick={() => setFilter("Billing")}
                    >
                      Billing
                    </button>
                    <button
                      className={filter === "Analytics" ? "active" : ""}
                      onClick={() => setFilter("Analytics")}
                    >
                      Analytics
                    </button>
                  </div>
                </div>

                {
                  filter === "newAppointment" &&
                  <dialog >
                    <div className="w-full md:w-max lg:w-[700px] bg-white rounded-md border">
                      <NewAppointment details={currentPatient} notify={notify} update={() => getAppointments(currentPatient.localID)}
                        cancel={(e) => { e.preventDefault(); setFilter('Appointments') }
                        } />
                    </div>
                  </dialog>
                }
                <div className="lg:flex gap-5">
                  <div>
                    <DetailSummary details={currentPatient} notify={notify} modifyPatient={handleModifyPatient} />
                  </div>
                  {
                    currentPatient && (
                      <div className="overflow-y-auto h-[600px] overflow-hidden w-full mt-8 lg:mt-0">
                        {filter === "Appointments" && <Appointments details={currentPatient} apts={apts} notify={notify} eventDone={() => getLocalData()} />}
                        {filter === "Notes" && <PatientNotes details={currentPatient} notes={notes} update={() => getAllNotes()} />}
                        {filter === "Documents" && <PatientDocuments details={currentPatient} notify={notify} eventDone={() => getLocalData()} />}
                        {filter === "newDocument" && <NewDocument details={currentPatient} onClose={() => setFilter('Documents')} notify={() => notify()} update={() => setFilter('Documents')} />}
                        {filter === "Prescriptions" && <PatientPrescriptions details={currentPatient} />}
                        {filter === "newPrescription" && <AddPrescription details={currentPatient} onClose={() => setFilter('Prescriptions')} update={() => setFilter('Prescriptions')} />}
                        {filter === "Billing" && <PatientBilling details={currentPatient} onClose={() => setFilter('Billing')} update={() => setFilter('Billing')} />}
                        {filter === "newInvoice" && <NewInvoice details={currentPatient} onClose={() => setFilter('Billing')} update={() => setFilter('Billing')} />}
                        {filter === "Analytics" && <PatientAnalysis details={currentPatient} />}
                      </div>
                    )
                  }
                </div>
                {popup === "newNote" && (
                  <div ref={newNoteRef}>
                    <NewNote onClose={closePopup} details={currentPatient} apts={apts} notify={notify} update={() => getAllNotes()} />

                  </div>
                )}
              </div>
            </div>
          )
      }
    </div>
  );
};
export default PatientDetails;
